import React from "react";
import { CircularProgress } from "@mui/material";
import { motion } from "framer-motion";
import { Button } from "./styles";
import colors from "../../constants/colors";
import { useReducedMotion } from "../../hooks/useReducedMotion";
import {
  buttonTapAnimation,
  buttonSpringTransition,
} from "../../animations/microInteractions";

interface KLButtonProps {
  title: string;
  type?: "submit" | "button" | "reset";
  onClick?: () => void;
  secondary?: boolean;
  warning?: boolean;
  noWidth?: boolean;
  noMarginTop?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

// Create motion component using styled-components forwarding
const MotionButton = motion.create(Button);

const KLButton: React.FC<KLButtonProps> = ({
  onClick,
  disabled = false,
  type = "submit",
  loading = false,
  secondary = false,
  warning = false,
  noWidth = false,
  noMarginTop = false,
  title,
}) => {
  const reducedMotion = useReducedMotion();

  return (
    <MotionButton
      data-testid="kl-button"
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      $secondary={secondary}
      $warning={warning}
      $noWidth={noWidth}
      $noMarginTop={noMarginTop}
      whileTap={disabled || loading || reducedMotion ? {} : buttonTapAnimation}
      transition={reducedMotion ? { duration: 0 } : buttonSpringTransition}
    >
      {loading ? <CircularProgress size={noWidth ? 18 : 24} sx={{ color: secondary ? colors.PURPLE : colors.WHITE }} /> : title}
    </MotionButton>
  );
};

export default KLButton;
